/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gold_Green_Newt_TalkInputs */

const en_gold_green_newt_talk = /** @type {(inputs: Gold_Green_Newt_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const de_gold_green_newt_talk = /** @type {(inputs: Gold_Green_Newt_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {Gold_Green_Newt_TalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gold_green_newt_talk = /** @type {((inputs?: Gold_Green_Newt_TalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gold_Green_Newt_TalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gold_green_newt_talk(inputs)
	return de_gold_green_newt_talk(inputs)
});